export default "__VITE_ASSET__cb8a3bce__"